// Browser-side country detection (real client IP). Server still fixes the $5 amount;
// this only selects the currency bucket (CA -> CAD, else USD).
const KEY = "evermore_country";

export async function getCountry() {
  const cached = sessionStorage.getItem(KEY);
  if (cached) return cached === "??" ? null : cached;
  const sources = [
    async () => (await (await fetch("https://get.geojs.io/v1/ip/country.json")).json()).country,
    async () => (await (await fetch("https://ipapi.co/country/")).text()).trim(),
  ];
  for (const src of sources) {
    try {
      const c = await src();
      if (c && /^[A-Za-z]{2}$/.test(c)) {
        const cc = c.toUpperCase();
        sessionStorage.setItem(KEY, cc);
        return cc;
      }
    } catch (_) { /* try next source */ }
  }
  sessionStorage.setItem(KEY, "??");
  return null;
}
